"use client";

import Script from "next/script";

interface CustomJsonLdProps {
  data: string;
}

export default function CustomJsonLd({ data }: CustomJsonLdProps) {
  return (
    <Script
      id={`json-ld`}
      type="application/ld+json"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(JSON.parse(data)) }}
    />
  );
}
